export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE';

export const setLanguage = (selectedLanguage) => ({
  type: SET_SELECTED_LANGUAGE,
  payload: {selectedLanguage},
});
